import React, { Component } from 'react';
import BaseLayout from './../../templates/base'
import ConceptEditForm from '../../elements/concepts/form';
import ConceptsAdd from './../../elements/concepts/widget/concepts_add';
import Loading from './../../elements/loading';

class ConceptCreate extends Component {
	render() {
		const { concepts, status } = this.props;
		return (
			concepts.isFetching || status.isFetching ? <Loading/>:<ConceptEditForm {...this.props}/>
		)
	}

	componentWillMount() {
		this.props.resetConcepts();
		//this.props.fetchStatus(1);
	}
}

//export default BaseLayout(ConceptCreate, {title: "Crear Concepto", subnav: {icon: 'fa-list-alt', name: 'Conceptos', actions: {url: '/gastos/conceptos/crear', name: 'Agregar Concepto'}}});
export default BaseLayout(ConceptCreate, {
	title: `Crear Concepto`,
	subnav: {
		icon: 'fa-list-alt',
		name: 'Conceptos',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <ConceptsAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/concepts/create.jsx